var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-scrollbar',{attrs:{"wrap-class":"app-main-scroll-wrap"}},[_c('transition',{attrs:{"name":"fade-transform","mode":"out-in"}},[_c('keep-alive',{attrs:{"include":_vm.cachedViews}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }